import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight, Layers, BarChart3, MapPin, Truck } from 'lucide-react';
import { Button } from './Button';
const quoteFactors = [{
  icon: <Layers className="w-4 h-4" data-id="element-355" />,
  label: 'Asset mix',
  desc: 'Bottles, crates, pallets, or all three'
}, {
  icon: <BarChart3 className="w-4 h-4" data-id="element-356" />,
  label: 'Monthly volume',
  desc: 'Pilot scale through enterprise'
}, {
  icon: <MapPin className="w-4 h-4" data-id="element-357" />,
  label: 'Geographies',
  desc: 'Distribution and return footprint'
}, {
  icon: <Truck className="w-4 h-4" data-id="element-358" />,
  label: 'Logistics',
  desc: 'Drop-points and route requirements'
}];
export const Pricing: React.FC = () => {
  return <section id="pricing" className="py-32 bg-cream border-t border-primary/5" data-id="element-359">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-360">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-361">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-362">
            <h2 className="font-display text-4xl md:text-5xl text-primary mb-6" data-id="element-363">
              Pay for the cycle, <br data-id="element-364" />
              not the asset.
            </h2>
            <p className="text-lg text-ink/70 mb-8" data-id="element-365">
              You pay a flat rate each time an asset goes out and comes back.
              That's it. No big purchase up front, no minimums, and no surprise
              logistics charges at the end of the month.
            </p>

            <div className="space-y-4 mb-10" data-id="element-366">
              {['No money down', 'We deliver clean, ready-to-use assets', 'We pick up the empties for you', 'Live tracking dashboard included', 'Loss and damage covered'].map((feature, i) => <div key={i} className="flex items-center gap-3 text-ink/80" data-id="element-367">
                  <CheckCircle2 className="w-5 h-5 text-leaf" data-id="element-368" />
                  <span data-id="element-369">{feature}</span>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 md:p-12 border border-primary/5 shadow-glossy-lg relative overflow-hidden gloss-card" data-id="element-370">
            <div className="absolute top-0 right-0 w-40 h-40 bg-leaf/15 rounded-bl-full" data-id="element-371" />

            <div className="relative z-10" data-id="element-372">
              <div className="mb-6" data-id="element-373">
                <span className="font-mono text-xs text-leaf uppercase tracking-widest" data-id="element-374">
                  Custom Quote
                </span>
              </div>

              <h3 className="font-display text-3xl md:text-4xl text-primary mb-4 leading-tight" data-id="element-375">
                Pricing built for your supply chain.
              </h3>
              <p className="text-ink/70 mb-8 pb-8 border-b border-primary/10 leading-relaxed" data-id="element-376">
                Every operation is different, so we'll put together a rate that
                fits yours. We'll also show you honestly how it stacks up
                against what you're spending on packaging today.
              </p>

              <div className="mb-8" data-id="element-377">
                <h4 className="font-medium text-primary mb-4 text-sm" data-id="element-378">
                  What we'll discuss:
                </h4>
                <div className="grid grid-cols-2 gap-3" data-id="element-379">
                  {quoteFactors.map((factor, i) => <div key={i} className="flex items-start gap-2.5 p-3 rounded-lg bg-mint/40 border border-leaf/10" data-id="element-380">
                      <div className="text-leaf mt-0.5 shrink-0" data-id="element-381">
                        {factor.icon}
                      </div>
                      <div data-id="element-382">
                        <div className="font-medium text-primary text-xs mb-0.5" data-id="element-383">
                          {factor.label}
                        </div>
                        <div className="text-[11px] text-ink/60 leading-snug" data-id="element-384">
                          {factor.desc}
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>

              <Button className="w-full" size="lg" data-id="element-385">
                Talk to our team <ArrowRight className="ml-2 w-5 h-5" data-id="element-386" />
              </Button>
              <p className="text-center text-xs text-muted mt-4 font-mono" data-id="element-387">
                No commitment. Response within 48 hours
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};